import Vue from 'vue';
import { Money } from '@razlet/utils';
import PricingDetalizationItem from './item';

export default class PricingDetalization {
  data = null;

  list = [];

  #isRefund = false;

  #withTotal = false;

  #showInitial = false;

  constructor (data, isRefund, withTotal = true, showInitial = false) {
    this.data = data;

    if (data) {
      const fares = data.fares || [];
      fares.forEach(fare => {
        this.list.push(new PricingDetalizationItem(fare, 'fare'));
      });
      const taxes = data.taxes || [];
      taxes.forEach(tax => {
        this.list.push(new PricingDetalizationItem(tax, 'tax'));
      });
      const penalty = data.penalty || [];
      penalty.forEach(penaltyItem => {
        this.list.push(new PricingDetalizationItem(penaltyItem, 'penalty'));
      });
    }

    this.#isRefund = isRefund;
    this.#withTotal = withTotal;
    this.#showInitial = showInitial;
    /* if (!isRefund) this.list.push(new PricingDetalizationItem({
      value: 15,
      description: 'something',
      basis: 'FIX',
      basisValue: 1,
      amount: 15,
      equivalentAmount: 15,
      currencyCode: 'RUB',
      rate: 15,
      equivalentCurrencyCode: 'RUB',
    }, 'additional')); */
  }

  get total () {
    return this.data?.total;
  }

  get totalRow () {
    return {
      description: `${this.#totalRowDescription}:`,
      rate: null,
      basisValue: '',
      basis: '',
      equivalentAmount: this.#showInitial ? this.initialPrice.value : this.computedPrice.value,
      equivalentCurrencyCode: this.currency,
    };
  }

  get #totalRowDescription () {
    return Vue.prototype.$localize.t(`base.${this.#isRefund ? 'totalRefund' : 'total'}`);
  }

  get listWithTotal () {
    return this.#withTotal
      ? this.list.concat([new PricingDetalizationItem(this.totalRow, 'total')])
      : this.list;
  }

  get selectedItems () {
    return this.list.filter(item => item.selected);
  }

  get currency () {
    if (!this.total) return 'RUB';
    return this.total.currency;
  }

  get computedPrice () {
    const value = this.selectedItems
      .reduce((res, item) => {
        return res + item.total.value;
      }, 0);

    return new Money({
      value,
      currency: this.currency,
    }, { fractionDigits: 2 });
  }

  get computedPriceCompact () {
    const value = this.selectedItems
      .reduce((res, item) => {
        return res + item.total.value;
      }, 0);

    return new Money({
      value,
      currency: this.currency,
    });
  }

  get initialPrice () {
    if (!this.data) return '';
    return new Money(this.total, { fractionDigits: 2 });
  }

  get initialPriceCompact () {
    if (!this.data) return '';
    return new Money(this.total);
  }

  get isAllSelected () {
    return this.selectedItems.length
      ? this.selectedItems.length === this.list.length
      : false;
  }

  get isAllDisabled () {
    return this.list.every(item => item.disabled);
  }

  get isIndeterminate () {
    return this.selectedItems.length > 0 &&
      this.selectedItems.length !== this.list.length;
  }

  selectAll (value) {
    this.list
      .filter(item => !item.disabled)
      .forEach(item => item.selected = value);
  }
};
